<template>
  <v-card class="elevation-12 ma-4">
    <v-toolbar dark color="primary">
      <v-toolbar-title>{{ $t("password-reset.title") }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu :nudge-width="100">
        <template v-slot:activator="{ on }">
          <v-toolbar-title v-on="on">
            <span><flag :iso="$i18n.locale.split('-')[1]" /></span>
            <v-icon dark>arrow_drop_down</v-icon>
          </v-toolbar-title>
        </template>
        <v-list>
          <v-list-item
            v-for="item in Object.keys(this.$i18n.messages)"
            :key="item"
            @click="$i18n.locale = item">
            <v-list-item-title><flag :iso="item | localeToCountry" /> {{ $t('langNative.'+item) }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-card-text class="v-card__text">
      <v-alert :value="confirmed" type="success" transition="scale-transition" >
        {{ $t("password-reset.message") }} {{ this.email }}
      </v-alert>
      <v-form ref="form" v-if="!confirmed" v-model="valid">
        <v-text-field prepend-icon="person" name="email" 
          :label="$t('profile.email')" type="text" v-model="email"
          :rules="[rules.required, rules.email]" />
      </v-form>
    </v-card-text>
    <v-card-actions class="v-card__actions" v-if="!confirmed" >
      <v-spacer></v-spacer>
      <v-btn color="primary" v-on:click="reset" >{{ $t("password-reset.reset") }}</v-btn>
    </v-card-actions>
    
  </v-card>
</template>

<script>
  import {
    VForm,
    VTextField,
    VCard,
    VCardActions,
    VCardText,
    VBtn,
    VAlert,
    VMenu
  } from 'vuetify/lib'
import fccapi from '../fccapi';

  export default {
    name: 'FCCPasswordReset',
    data: () => ({
      drawer: null,
      email: null,
      rules: {
        required: value =>  !!value || 'Required',
        email: value => {
          const pattern = /^\s*(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/
          return pattern.test(value) || 'Invalid e-mail'
        }
      },
      valid: false,
      confirmed: false
    }),
    methods: {
      reset: function () {
        if(this.valid){
            fccapi.post("password-reset", {Email: this.email}).then(()=>{
                this.confirmed = true;
            }).catch(()=>{});
        }
        else{
          this.$refs.form.validate();
        }
      },
      keyPress(key) {
        if(key.keyCode == 13) this.submitLogin();
      }
    },
    props: {
      source: String
    },
    components: {
      VCard,
      VForm,
      VTextField,
      VCardActions,
      VCardText,
      VBtn,
      VAlert,
      VMenu
    }
  }
</script>